var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaceTag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#fff;}.a{opacity:0;}.b,.c,.d,.e,.f{fill-rule:evenodd;}.c{fill:#428bca;}.d{fill:#66ceef;}.e{fill:#1a87c7;}.f{fill:#bdedf8;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-955 -523)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 80,
    height: 80,
    transform: "translate(955 523)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 4.257)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(16616 13319.743)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-15635 -12795)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M979.706,1882.357c-4.9,2.83-8.876,9.711-8.876,15.367s3.973,7.949,8.876,5.12,8.867-9.708,8.867-15.365-3.976-7.951-8.867-5.123Zm0,31.524c-3-2.307-7.294-4.882-9.846-7.593a9.619,9.619,0,0,1-2.2-6.734c0-7.679,5.39-17.014,12.045-20.852s12.035-.729,12.035,6.951a23.039,23.039,0,0,1-2.19,9.267c-2.559,5.664-6.855,13.194-9.845,18.962Z",
    transform: "translate(-965.016 -1875.414)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M979.7,1882.348h0Zm.141.26c-4.808,2.776-8.715,9.554-8.715,15.108,0,2.624.868,4.573,2.45,5.484s3.7.691,5.971-.622c4.811-2.774,8.718-9.55,8.718-15.106,0-2.625-.865-4.572-2.442-5.484s-3.706-.693-5.982.62Zm-4.108,21.744a4.868,4.868,0,0,1-2.46-.635c-1.769-1.022-2.747-3.155-2.747-6,0-5.742,4.045-12.753,9.02-15.624h0c2.471-1.423,4.8-1.645,6.57-.621s2.745,3.155,2.745,6c0,5.746-4.042,12.753-9.02,15.624a8.342,8.342,0,0,1-4.108,1.256Zm9.337-27.009a10.686,10.686,0,0,0-5.23,1.607c-6.552,3.785-11.883,13.026-11.883,20.6a9.3,9.3,0,0,0,2.115,6.53,44.175,44.175,0,0,0,6.584,5.235c1.047.732,2.039,1.426,2.94,2.11.927-1.779,1.955-3.694,3.049-5.715,2.41-4.47,4.894-9.093,6.621-12.92a22.585,22.585,0,0,0,2.173-9.141c0-3.6-1.206-6.28-3.38-7.538a5.9,5.9,0,0,0-2.99-.764Zm-5.371,36.827a.3.3,0,0,1-.186-.06c-.959-.742-2.047-1.5-3.2-2.311a44.73,44.73,0,0,1-6.676-5.314,9.9,9.9,0,0,1-2.275-6.939c0-7.76,5.467-17.232,12.186-21.112,3.311-1.914,6.443-2.211,8.812-.846s3.678,4.231,3.678,8.057a23.3,23.3,0,0,1-2.224,9.388c-1.734,3.844-4.227,8.478-6.643,12.956-1.152,2.14-2.241,4.159-3.209,6.022a.294.294,0,0,1-.2.155A.234.234,0,0,1,979.7,1914.169Z",
    transform: "translate(-965.007 -1875.404)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M979.922,1886.785a11.654,11.654,0,0,0-5.281,9.145c0,3.369,2.359,4.732,5.281,3.049a11.677,11.677,0,0,0,5.28-9.147C985.2,1886.465,982.836,1885.1,979.922,1886.785Z",
    transform: "translate(-965.232 -1875.693)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M979.912,1886.775h0Zm2.35-.423a4.526,4.526,0,0,0-2.208.683h0a11.353,11.353,0,0,0-5.128,8.885,2.929,2.929,0,0,0,4.833,2.79,11.345,11.345,0,0,0,5.131-8.888,3.43,3.43,0,0,0-1.4-3.158,2.4,2.4,0,0,0-1.229-.312Zm-4.709,13.641a2.986,2.986,0,0,1-1.523-.4,3.987,3.987,0,0,1-1.7-3.676,12.036,12.036,0,0,1,5.433-9.4,3.508,3.508,0,0,1,5.728,3.305,12,12,0,0,1-5.433,9.406A5.059,5.059,0,0,1,977.553,1899.993Z",
    transform: "translate(-965.223 -1875.683)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M983.58,1886.372c-2.468-1.423-4.161-2.987-7.6.227-3.089,2.887-5.415,9.325-2.163,11.384l2.29,1.326C971.384,1896.033,978.383,1883.917,983.58,1886.372Z",
    transform: "translate(-965.158 -1875.651)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M979.652,1885c-.977,0-2.064.48-3.478,1.805-2.233,2.084-3.849,5.839-3.613,8.366a3.169,3.169,0,0,0,1.406,2.546l.766.445c-1.045-2.077-.287-5.187,1.127-7.635s3.739-4.666,6.074-4.785a4.714,4.714,0,0,0-2.283-.742ZM976.1,1899.6a.25.25,0,0,1-.142-.041l-2.3-1.325a3.791,3.791,0,0,1-1.694-3c-.286-3.051,1.711-6.9,3.809-8.858,3.274-3.066,5.127-1.952,7.275-.662.218.129.437.263.672.4a.3.3,0,0,1,.111.4.3.3,0,0,1-.388.132c-2.512-1.185-5.423,1.343-7.066,4.194s-2.384,6.642-.1,8.223a.305.305,0,0,1,.076.406A.288.288,0,0,1,976.1,1899.6Z",
    transform: "translate(-965.148 -1875.642)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M967.486,1904.92c-5.121-5.884-.436-17.118,4.11-22.594,3.066-3.692,9.2-8.611,14.252-5.834l2.29,1.323c-6.435-3.363-13.956,4.526-17.022,9.831-2.982,5.164-5.82,14.239-.833,19.107,2.45,2.4,6.476,4.915,9.348,7.087a47.994,47.994,0,0,1-5.391-3.562A45.565,45.565,0,0,1,967.486,1904.92Z",
    transform: "translate(-964.942 -1875.371)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M967.694,1904.708c.624.632,1.246,1.2,1.889,1.741-4.59-5.253-1.424-14.31,1.262-18.962,2.849-4.93,9-11.409,14.857-10.741l-.015-.009c-4.92-2.7-11.033,2.352-13.871,5.768-4.793,5.776-8.893,16.7-4.12,22.2Zm11.927,9.421a.324.324,0,0,1-.153-.04,35.561,35.561,0,0,1-3.914-2.509c-.4-.288-.861-.624-1.5-1.069l-.422-.3a43.158,43.158,0,0,1-6.367-5.092c-.008,0-.008-.008-.015-.011-5.222-6.008-.64-17.265,4.111-22.982,3.663-4.417,9.693-8.616,14.62-5.907l2.3,1.329a.291.291,0,0,1,.11.4.3.3,0,0,1-.4.122c-6.167-3.224-13.476,4.247-16.634,9.714-2.688,4.656-5.9,13.844-.879,18.746a53.306,53.306,0,0,0,6.251,4.849c1.094.774,2.133,1.506,3.067,2.214a.288.288,0,0,1,.065.4A.292.292,0,0,1,979.621,1914.129Z",
    transform: "translate(-964.932 -1875.361)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M972.537,1902.752c3.648,4.031,9.889-.922,12.625-4.872l.96-1.521c2.249-4.016,4.556-11.6,0-14.486a4.172,4.172,0,0,0-1.255-.481c2.99,2.9,1.156,9.612-.741,13.115-2.071,3.821-6.916,9.2-11.531,8.261Z",
    transform: "translate(-965.167 -1875.548)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M973.429,1903.161a3.98,3.98,0,0,0,2.711.771c3.048-.2,6.723-3.285,8.77-6.23l.959-1.513c2.332-4.187,4.3-11.407.084-14.076l-.2-.111c2.154,3.336.4,9.354-1.373,12.639-1.988,3.675-6.445,8.72-10.951,8.519Zm2.391,1.378a4.59,4.59,0,0,1-3.518-1.6.3.3,0,0,1-.026-.359.283.283,0,0,1,.329-.13l.069.018c4.437.906,9.22-4.5,11.182-8.116,1.988-3.683,3.554-10.08.793-12.76a.3.3,0,0,1-.051-.356.287.287,0,0,1,.32-.149,4.615,4.615,0,0,1,1.348.513c4.928,3.122,2.233,11.1.11,14.892l-.968,1.537c-2.072,2.98-5.836,6.275-9.231,6.493C976.057,1904.534,975.939,1904.539,975.82,1904.539Z",
    transform: "translate(-965.158 -1875.539)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1083.289 -1393.163)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M2080.458,1997l-10.862-6.271v-.842l10.862,6.271Z",
    transform: "translate(-0.086 -11.364)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2069.733,1990.516l10.418,6.015,0-.33-10.42-6.014v.329Zm10.639,6.62a.224.224,0,0,1-.109-.028l-10.864-6.271a.225.225,0,0,1-.109-.193v-.842a.224.224,0,0,1,.112-.193.227.227,0,0,1,.223,0l10.862,6.271a.218.218,0,0,1,.11.193v.84a.22.22,0,0,1-.223.221Z",
    transform: "translate(0 -11.279)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M2080.46,1993.885l-10.862-6.272,9.974-5.877,10.979,6.338Z",
    transform: "translate(-0.086 -9.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2069.952,1987.524l10.421,6.018,9.647-5.555-10.535-6.083-9.534,5.62Zm10.421,6.5a.223.223,0,0,1-.111-.03l-10.862-6.272a.222.222,0,0,1,0-.384l9.974-5.878a.222.222,0,0,1,.225,0l10.977,6.338a.224.224,0,0,1,.113.193.222.222,0,0,1-.113.192l-10.089,5.811A.222.222,0,0,1,2080.374,1994.021Z",
    transform: "translate(0 -9.004)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M2084.663,1996.337l6.9-3.973,3.19-1.837v.842l-10.093,5.81Z",
    transform: "translate(-4.289 -11.543)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2084.8,1996.379v.329l9.646-5.553v-.329l-9.646,5.554Zm-.223.935a.218.218,0,0,1-.112-.031.221.221,0,0,1-.11-.191l0-.841a.223.223,0,0,1,.11-.193l10.09-5.811a.231.231,0,0,1,.223,0,.225.225,0,0,1,.112.192v.842a.219.219,0,0,1-.112.192l-10.091,5.811A.226.226,0,0,1,2084.575,1997.315Z",
    transform: "translate(-4.203 -11.457)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M2079.906,1970.649l-6.459-3.729.006-1.294,6.458,3.731Z",
    transform: "translate(-1.16 -4.595)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2073.583,1966.706l6.017,3.474v-.781l-6.014-3.473,0,.78Zm6.236,4.08a.206.206,0,0,1-.11-.03l-6.46-3.731a.224.224,0,0,1-.112-.193l.006-1.292a.225.225,0,0,1,.112-.191.215.215,0,0,1,.22,0l6.461,3.731a.223.223,0,0,1,.112.193l-.006,1.292a.221.221,0,0,1-.112.191A.212.212,0,0,1,2079.819,1970.786Z",
    transform: "translate(-1.074 -4.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2082.405,1970.7l.005-1.292,6.247-3.6-.005,1.294Z",
    transform: "translate(-3.659 -4.647)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2082.546,1969.451v.781l5.8-3.341,0-.78-5.8,3.34Zm-.226,1.387a.205.205,0,0,1-.11-.03.221.221,0,0,1-.112-.193l.006-1.292a.217.217,0,0,1,.11-.191l6.247-3.6a.222.222,0,0,1,.332.193l0,1.292a.227.227,0,0,1-.111.193l-6.247,3.595A.213.213,0,0,1,2082.319,1970.838Z",
    transform: "translate(-3.574 -4.562)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2082.127,1961l6.005,3.468-.561.323-5.444-3.144Z",
    transform: "translate(-3.582 -3.304)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2082.264,1961.43l5.221,3.014.117-.066-5.338-3.083v.134Zm5.221,3.495a.234.234,0,0,1-.112-.03l-5.443-3.144a.221.221,0,0,1-.11-.193v-.647a.222.222,0,0,1,.11-.193.229.229,0,0,1,.223,0l6.005,3.469a.223.223,0,0,1,0,.386l-.563.322A.231.231,0,0,1,2087.486,1964.925Z",
    transform: "translate(-3.496 -3.218)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2074.636,1964.665l-.563-.325,5.806-3.343v.648Z",
    transform: "translate(-1.335 -3.304)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2074.432,1964.254l.119.068,5.023-2.892v-.136l-5.142,2.96Zm.119.548a.226.226,0,0,1-.111-.03l-.563-.325a.224.224,0,0,1,0-.386l5.805-3.343a.229.229,0,0,1,.223,0,.224.224,0,0,1,.111.193v.647a.224.224,0,0,1-.111.193l-5.246,3.021A.23.23,0,0,1,2074.551,1964.8Z",
    transform: "translate(-1.249 -3.218)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2080.227,1968.125l-5.637-3.254,5.43-3.128,5.636,3.257Z",
    transform: "translate(-1.479 -3.512)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2074.948,1964.786l5.193,3,4.986-2.872-5.192-3-4.987,2.872Zm5.193,3.477a.213.213,0,0,1-.11-.03l-5.64-3.257a.216.216,0,0,1-.109-.19.225.225,0,0,1,.109-.193l5.433-3.125a.217.217,0,0,1,.222,0l5.636,3.255a.222.222,0,0,1,0,.384l-5.431,3.128A.223.223,0,0,1,2080.141,1968.263Z",
    transform: "translate(-1.393 -3.426)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2079.913,1967.966l-6.458-3.731,6.245-3.594,6.46,3.729Z",
    transform: "translate(-1.162 -3.205)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2073.812,1964.151l6.015,3.473,5.8-3.341-6.014-3.472-5.8,3.34Zm6.015,3.952a.218.218,0,0,1-.111-.03l-6.458-3.731a.216.216,0,0,1-.112-.193.221.221,0,0,1,.112-.191l6.247-3.6a.219.219,0,0,1,.221,0l6.458,3.73a.219.219,0,0,1,.111.191.224.224,0,0,1-.111.193l-6.245,3.6A.213.213,0,0,1,2079.827,1968.1Z",
    transform: "translate(-1.076 -3.118)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M2080.8,1967.365l-4.013-2.318v-4.14l4.016,2.32Z",
    transform: "translate(-2.092 -3.279)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2076.924,1964.834l3.568,2.061,0-3.626-3.57-2.062v3.627Zm3.79,2.668a.214.214,0,0,1-.108-.029l-4.017-2.32a.219.219,0,0,1-.112-.191v-4.14a.222.222,0,0,1,.112-.191.219.219,0,0,1,.223,0l4.014,2.318a.217.217,0,0,1,.112.193v4.138a.221.221,0,0,1-.223.221Z",
    transform: "translate(-2.006 -3.193)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2080.8,1962.352l-4.016-2.32,3.834-2.263,4.062,2.346Z",
    transform: "translate(-2.092 -2.403)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2077.143,1959.945l3.575,2.064,3.436-1.981-3.615-2.087-3.4,2Zm3.575,2.542a.207.207,0,0,1-.111-.03l-4.017-2.318a.226.226,0,0,1-.112-.19.22.22,0,0,1,.112-.192l3.833-2.263a.233.233,0,0,1,.225,0l4.061,2.346a.221.221,0,0,1,.112.193.227.227,0,0,1-.112.193l-3.882,2.234A.206.206,0,0,1,2080.717,1962.487Z",
    transform: "translate(-2.006 -2.318)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2082.357,1963.259l3.88-2.237v4.138l-3.882,2.237Z",
    transform: "translate(-3.645 -3.311)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2082.491,1963.3v3.627l3.436-1.98v-3.627l-3.438,1.98Zm-.223,4.233a.228.228,0,0,1-.11-.029.225.225,0,0,1-.112-.193v-4.139a.217.217,0,0,1,.113-.193l3.879-2.237a.227.227,0,0,1,.223,0,.222.222,0,0,1,.112.193v4.139a.223.223,0,0,1-.112.193l-3.882,2.237A.22.22,0,0,1,2082.268,1967.533Z",
    transform: "translate(-3.559 -3.225)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M2081.452,1961.727l-2.233-1.288,2.133-1.258,2.257,1.3Z",
    transform: "translate(-2.77 -2.797)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2079.573,1960.351l1.793,1.033,1.713-.986-1.813-1.048-1.693,1Zm1.793,1.513a.23.23,0,0,1-.112-.03l-2.231-1.289a.222.222,0,0,1,0-.385l2.132-1.259a.229.229,0,0,1,.224,0l2.259,1.3a.222.222,0,0,1,0,.385l-2.159,1.243A.231.231,0,0,1,2081.366,1961.864Z",
    transform: "translate(-2.684 -2.711)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M2081.451,1960.664l-2.235-1.288v-4l2.235,1.289Z",
    transform: "translate(-2.77 -1.734)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2079.353,1959.161l1.789,1.034V1956.7l-1.789-1.031v3.49Zm2.012,1.64a.23.23,0,0,1-.112-.03l-2.233-1.289a.22.22,0,0,1-.111-.192v-4.005a.22.22,0,0,1,.111-.193.225.225,0,0,1,.221,0l2.233,1.291a.218.218,0,0,1,.111.191v4a.22.22,0,0,1-.111.193A.231.231,0,0,1,2081.366,1960.8Z",
    transform: "translate(-2.684 -1.648)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2081.451,1956.173l-2.235-1.288,2.134-1.258,2.257,1.3Z",
    transform: "translate(-2.77 -1.247)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2079.573,1954.8l1.793,1.035,1.713-.988-1.813-1.046-1.693,1Zm1.793,1.513a.21.21,0,0,1-.112-.03l-2.233-1.288a.217.217,0,0,1-.111-.191.222.222,0,0,1,.11-.193l2.132-1.26a.221.221,0,0,1,.224,0l2.259,1.3a.222.222,0,0,1,0,.386l-2.159,1.242A.21.21,0,0,1,2081.366,1956.309Z",
    transform: "translate(-2.684 -1.161)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2082.316,1956.677l2.157-1.243v4l-2.157,1.243Z",
    transform: "translate(-3.635 -1.752)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2082.45,1956.72v3.493l1.715-.988v-3.49l-1.715.986Zm-.221,4.1a.231.231,0,0,1-.112-.03.22.22,0,0,1-.112-.193v-4a.219.219,0,0,1,.112-.191l2.159-1.245a.227.227,0,0,1,.22,0,.219.219,0,0,1,.112.193v4.005a.219.219,0,0,1-.112.193l-2.158,1.243A.232.232,0,0,1,2082.229,1960.819Z",
    transform: "translate(-3.548 -1.666)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2082.18,1954.108a.223.223,0,0,1-.221-.223v-4a.222.222,0,1,1,.444,0v4A.223.223,0,0,1,2082.18,1954.108Z",
    transform: "translate(-3.535 -0.141)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M2082.159,1950.005a.271.271,0,1,0-.27-.272A.271.271,0,0,0,2082.159,1950.005Z",
    transform: "translate(-3.515 -0.086)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2082.073,1949.6a.048.048,0,0,0-.05.047c0,.055.1.055.1,0a.048.048,0,0,0-.048-.047Zm0,.542a.494.494,0,1,1,.492-.5A.5.5,0,0,1,2082.073,1950.143Z",
    transform: "translate(-3.429)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M2080,1973.731l-6.233-3.6,0-.737,6.23,3.6Z",
    transform: "translate(-1.248 -5.647)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2073.9,1969.916l5.786,3.342v-.221l-5.787-3.343,0,.223Zm6.012,3.95a.232.232,0,0,1-.111-.028l-6.231-3.6a.22.22,0,0,1-.112-.191l-.006-.738a.222.222,0,0,1,.111-.193.229.229,0,0,1,.224,0l6.23,3.6a.221.221,0,0,1,.111.189l.008.738a.222.222,0,0,1-.112.193A.207.207,0,0,1,2079.912,1973.865Z",
    transform: "translate(-1.161 -5.561)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M2079.993,1972.492l-6.232-3.6,0-1.292,6.233,3.6Z",
    transform: "translate(-1.248 -5.146)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2073.9,1968.68l5.791,3.343v-.779l-5.79-3.343,0,.78Zm6.01,3.95a.213.213,0,0,1-.11-.03l-6.234-3.6a.226.226,0,0,1-.111-.193l.006-1.292a.216.216,0,0,1,.112-.19.22.22,0,0,1,.22,0l6.234,3.6a.223.223,0,0,1,.112.193l-.006,1.292a.224.224,0,0,1-.223.221Z",
    transform: "translate(-1.161 -5.061)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M2082.405,1972.542l.005-1.292,6.026-3.468-.006,1.292Z",
    transform: "translate(-3.659 -5.197)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2082.546,1971.293v.78l5.579-3.212,0-.781-5.582,3.213Zm-.226,1.386a.212.212,0,0,1-.11-.03.221.221,0,0,1-.112-.192l.006-1.293a.218.218,0,0,1,.11-.19l6.028-3.47a.22.22,0,0,1,.221,0,.224.224,0,0,1,.112.193l-.006,1.293a.225.225,0,0,1-.112.192l-6.026,3.468A.22.22,0,0,1,2082.319,1972.679Z",
    transform: "translate(-3.574 -5.111)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M2079.993,1975.308l-6.232-3.6,0-1.292,6.233,3.6Z",
    transform: "translate(-1.248 -5.932)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2073.9,1971.493l5.791,3.345v-.78l-5.79-3.345,0,.781Zm6.01,3.95a.226.226,0,0,1-.11-.029l-6.234-3.6a.227.227,0,0,1-.111-.195l.006-1.293a.222.222,0,0,1,.332-.19l6.234,3.6a.225.225,0,0,1,.112.193l-.006,1.292a.222.222,0,0,1-.112.192A.233.233,0,0,1,2079.907,1975.443Z",
    transform: "translate(-1.161 -5.846)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M2082.405,1975.358l.005-1.292,6.026-3.47-.006,1.292Z",
    transform: "translate(-3.659 -5.982)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2082.546,1974.109v.778l5.579-3.213,0-.778-5.582,3.213Zm-.226,1.386a.227.227,0,0,1-.11-.03.222.222,0,0,1-.112-.192l.006-1.294a.224.224,0,0,1,.11-.191l6.028-3.469a.22.22,0,0,1,.221,0,.225.225,0,0,1,.112.193l-.006,1.294a.223.223,0,0,1-.112.19l-6.026,3.47A.236.236,0,0,1,2082.319,1975.495Z",
    transform: "translate(-3.574 -5.896)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M2079.993,1978.124l-6.232-3.6,0-1.292,6.233,3.6Z",
    transform: "translate(-1.248 -6.717)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2073.9,1974.309l5.791,3.343v-.78l-5.79-3.343,0,.78Zm6.01,3.95a.207.207,0,0,1-.11-.03l-6.234-3.6a.227.227,0,0,1-.111-.193l.006-1.291a.222.222,0,0,1,.332-.192l6.234,3.6a.221.221,0,0,1,.112.192l-.006,1.293a.223.223,0,0,1-.112.192A.226.226,0,0,1,2079.907,1978.259Z",
    transform: "translate(-1.161 -6.631)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M2082.405,1978.175l.005-1.294,6.026-3.468-.006,1.292Z",
    transform: "translate(-3.659 -6.768)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2082.546,1976.923v.78l5.579-3.213,0-.781-5.582,3.214Zm-.226,1.386a.206.206,0,0,1-.11-.03.22.22,0,0,1-.112-.193l.006-1.292a.223.223,0,0,1,.11-.193l6.028-3.467a.216.216,0,0,1,.221,0,.222.222,0,0,1,.112.193l-.006,1.291a.225.225,0,0,1-.112.193l-6.026,3.469A.227.227,0,0,1,2082.319,1978.31Z",
    transform: "translate(-3.574 -6.682)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M2079.993,1980.938l-6.232-3.6,0-1.294,6.233,3.6Z",
    transform: "translate(-1.248 -7.503)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2073.9,1977.125l5.791,3.344v-.78l-5.79-3.344,0,.78Zm6.01,3.95a.208.208,0,0,1-.11-.03l-6.234-3.6a.228.228,0,0,1-.111-.193l.006-1.292a.224.224,0,0,1,.112-.193.221.221,0,0,1,.22,0l6.234,3.6a.222.222,0,0,1,.112.192l-.006,1.292a.217.217,0,0,1-.112.19A.214.214,0,0,1,2079.907,1981.075Z",
    transform: "translate(-1.161 -7.417)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M2082.405,1980.991l.005-1.294,6.026-3.468-.006,1.292Z",
    transform: "translate(-3.659 -7.554)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2082.546,1979.74v.78l5.579-3.213,0-.78-5.582,3.214Zm-.226,1.386a.208.208,0,0,1-.11-.03.219.219,0,0,1-.112-.192l.006-1.293a.22.22,0,0,1,.11-.192l6.028-3.469a.222.222,0,0,1,.221,0,.225.225,0,0,1,.112.193l-.006,1.292a.225.225,0,0,1-.112.192l-6.026,3.47A.236.236,0,0,1,2082.319,1981.126Z",
    transform: "translate(-3.574 -7.468)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M2079.993,1983.755l-6.232-3.6,0-1.292,6.233,3.6Z",
    transform: "translate(-1.248 -8.288)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2073.9,1979.941l5.791,3.344v-.78l-5.79-3.344,0,.78Zm6.01,3.95a.213.213,0,0,1-.11-.03l-6.234-3.6a.225.225,0,0,1-.111-.193l.006-1.292a.223.223,0,0,1,.112-.193.219.219,0,0,1,.22,0l6.234,3.6a.222.222,0,0,1,.112.193l-.006,1.292a.223.223,0,0,1-.223.221Z",
    transform: "translate(-1.161 -8.203)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M2082.405,1983.806l.005-1.292,6.026-3.468-.006,1.292Z",
    transform: "translate(-3.659 -8.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2082.546,1982.556v.78l5.579-3.213,0-.78-5.582,3.214Zm-.226,1.386a.213.213,0,0,1-.11-.03.222.222,0,0,1-.112-.193l.006-1.292a.225.225,0,0,1,.11-.193l6.028-3.468a.222.222,0,0,1,.333.193l-.006,1.292a.225.225,0,0,1-.112.193l-6.026,3.469A.22.22,0,0,1,2082.319,1983.943Z",
    transform: "translate(-3.574 -8.254)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M2079.993,1990.625l-6.232-3.6,0-2.53,6.233,3.6Z",
    transform: "translate(-1.248 -9.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2073.9,1986.812l5.789,3.342.006-2.015-5.792-3.343,0,2.017Zm6.011,3.95a.228.228,0,0,1-.11-.03l-6.234-3.6a.225.225,0,0,1-.111-.192l.006-2.53a.219.219,0,0,1,.112-.193.224.224,0,0,1,.22,0l6.234,3.6a.224.224,0,0,1,.112.193l-.006,2.53a.224.224,0,0,1-.112.193A.228.228,0,0,1,2079.907,1990.762Z",
    transform: "translate(-1.161 -9.774)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M2082.405,1990.675l.005-2.529,6.026-3.47-.006,2.531Z",
    transform: "translate(-3.659 -9.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2082.546,1988.189l0,2.015,5.581-3.211,0-2.017-5.582,3.214Zm-.226,2.624a.227.227,0,0,1-.11-.03.221.221,0,0,1-.112-.193l.006-2.53a.224.224,0,0,1,.11-.193l6.028-3.47a.224.224,0,0,1,.221,0,.222.222,0,0,1,.112.193l-.006,2.529a.225.225,0,0,1-.112.193l-6.026,3.468A.229.229,0,0,1,2082.319,1990.813Z",
    transform: "translate(-3.574 -9.825)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M2079.989,1986.564l0-1.292-6.22-3.593,0,1.292C2077.009,1984.846,2076.746,1984.7,2079.989,1986.564Z",
    transform: "translate(-1.248 -9.074)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2073.9,1982.757c2.728,1.577,2.911,1.683,5.035,2.9l.748.43v-.778l-5.779-3.336,0,.779Zm6.005,3.944a.218.218,0,0,1-.109-.03l-1.083-.624c-2.153-1.239-2.312-1.332-5.148-2.969a.226.226,0,0,1-.111-.193l.006-1.292a.222.222,0,0,1,.332-.193l6.219,3.594a.218.218,0,0,1,.112.192l.006,1.292a.224.224,0,0,1-.224.223Z",
    transform: "translate(-1.161 -8.988)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M2084.2,1966.709l-.313-.182.006.006.009,0,.316.182-.009,0Z",
    transform: "translate(-4.072 -4.847)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2084.133,1966.855a.244.244,0,0,1-.094-.021h0l-.017-.009-.316-.181-.009-.006-.005-.006a.227.227,0,0,1-.074-.3.213.213,0,0,1,.295-.087l.316.182a.042.042,0,0,0,.011.007l.006,0a.222.222,0,0,1-.111.414Z",
    transform: "translate(-3.99 -4.761)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M2086.036,1963.566l-.315-.184-.009,0-.007-.005.315.183.009,0Z",
    transform: "translate(-4.58 -3.967)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2085.95,1963.7a.212.212,0,0,1-.094-.021l-.011-.006-.336-.195a.221.221,0,0,1,.2-.394h0a.107.107,0,0,1,.021.009l.33.193a.222.222,0,0,1-.109.414Z",
    transform: "translate(-4.494 -3.881)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2084.013,1964.185a2.294,2.294,0,0,1,.8-.846.692.692,0,0,1,1.135.655,2.514,2.514,0,0,1-1.135,1.965.693.693,0,0,1-1.135-.655A2.327,2.327,0,0,1,2084.013,1964.185Z",
    transform: "translate(-4.015 -3.914)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2083.927,1964.1h0Zm1.307-.777a.825.825,0,0,0-.4.124,2.089,2.089,0,0,0-.72.766h0a2.125,2.125,0,0,0-.3,1.006.592.592,0,0,0,.221.542.6.6,0,0,0,.58-.079,2.284,2.284,0,0,0,1.025-1.772.6.6,0,0,0-.222-.542.352.352,0,0,0-.185-.045Zm-1.014,2.929a.823.823,0,0,1-.4-.105,1.01,1.01,0,0,1-.443-.928,2.739,2.739,0,0,1,1.244-2.157.908.908,0,0,1,1.468.848,2.74,2.74,0,0,1-1.247,2.157A1.246,1.246,0,0,1,2084.22,1966.251Z",
    transform: "translate(-3.929 -3.828)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2085.137,1965.421a.2.2,0,0,1-.066-.011l-.526-.164a.222.222,0,1,1,.133-.423l.527.164a.222.222,0,0,1-.068.434Z",
    transform: "translate(-4.213 -4.368)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2085.117,1965.287a.236.236,0,0,1-.1-.022.222.222,0,0,1-.1-.3l.493-.98a.221.221,0,1,1,.394.2l-.491.982A.222.222,0,0,1,2085.117,1965.287Z",
    transform: "translate(-4.354 -4.103)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2075.218,1966.392a.222.222,0,0,1-.192-.111.225.225,0,0,1,.081-.3l1.069-.616a.224.224,0,0,1,.3.083.221.221,0,0,1-.082.3l-1.071.616a.211.211,0,0,1-.11.03Zm10.163.2a.242.242,0,0,1-.112-.028l-1.2-.694a.22.22,0,0,1-.081-.3.223.223,0,0,1,.3-.082l1.2.692a.221.221,0,0,1-.111.413Z",
    transform: "translate(-1.592 -4.513)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M2082.4,1986.615l0-1.292,6.028-3.458,0,1.292Z",
    transform: "translate(-3.656 -9.126)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2082.53,1985.365l0,.78,5.576-3.206,0-.777-5.583,3.2Zm-.219,1.386a.224.224,0,0,1-.22-.221l-.006-1.293a.221.221,0,0,1,.112-.192l6.03-3.459a.22.22,0,0,1,.223,0,.225.225,0,0,1,.109.193l-.006,1.292a.218.218,0,0,1-.112.192l-6.018,3.459A.227.227,0,0,1,2082.311,1986.752Z",
    transform: "translate(-3.57 -9.04)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2082.412,1973.779l6.017-3.474,0-.738-6.012,3.473Z",
    transform: "translate(-3.661 -5.695)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2082.556,1973.084l0,.221,5.567-3.217,0-.223-5.567,3.219Zm-.229.829a.218.218,0,0,1-.221-.223l.006-.738a.225.225,0,0,1,.111-.189l6.013-3.476a.223.223,0,0,1,.223,0,.226.226,0,0,1,.112.195l-.006.737a.218.218,0,0,1-.109.19l-6.017,3.476A.226.226,0,0,1,2082.327,1973.913Z",
    transform: "translate(-3.576 -5.609)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M2080,1976.544l-6.233-3.6,0-.737,6.23,3.6Z",
    transform: "translate(-1.248 -6.432)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2073.9,1972.73l5.786,3.343v-.222l-5.787-3.342,0,.221Zm6.012,3.952a.22.22,0,0,1-.111-.03l-6.231-3.6a.217.217,0,0,1-.112-.19l-.006-.737a.225.225,0,0,1,.335-.195l6.23,3.6a.221.221,0,0,1,.111.19l.008.737a.225.225,0,0,1-.112.194A.208.208,0,0,1,2079.912,1976.681Z",
    transform: "translate(-1.161 -6.346)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2082.412,1976.593l6.017-3.473,0-.737-6.012,3.474Z",
    transform: "translate(-3.661 -6.481)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2082.556,1975.9l0,.222,5.567-3.216,0-.223-5.567,3.217Zm-.229.831a.223.223,0,0,1-.113-.03.226.226,0,0,1-.108-.194l.006-.738a.225.225,0,0,1,.111-.19l6.013-3.474a.224.224,0,0,1,.223,0,.22.22,0,0,1,.112.193l-.006.738a.222.222,0,0,1-.109.191l-6.017,3.474A.214.214,0,0,1,2082.327,1976.73Z",
    transform: "translate(-3.576 -6.395)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M2080,1979.361l-6.233-3.6,0-.737,6.23,3.6Z",
    transform: "translate(-1.248 -7.217)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2073.9,1975.545l5.786,3.342v-.221l-5.787-3.343,0,.223Zm6.012,3.95a.24.24,0,0,1-.111-.028l-6.231-3.6a.218.218,0,0,1-.112-.191l-.006-.736a.223.223,0,0,1,.335-.2l6.23,3.6a.222.222,0,0,1,.111.191l.008.736a.221.221,0,0,1-.112.193A.207.207,0,0,1,2079.912,1979.5Z",
    transform: "translate(-1.161 -7.131)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2082.412,1979.409l6.017-3.474,0-.739-6.012,3.476Z",
    transform: "translate(-3.661 -7.266)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2082.556,1978.715l0,.221,5.567-3.217,0-.221-5.567,3.216Zm-.229.83a.219.219,0,0,1-.221-.223l.006-.736a.227.227,0,0,1,.111-.191l6.013-3.473a.223.223,0,0,1,.334.192l-.006.739a.218.218,0,0,1-.109.189l-6.017,3.476A.232.232,0,0,1,2082.327,1979.545Z",
    transform: "translate(-3.576 -7.18)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M2080,1982.178l-6.233-3.6,0-.736,6.23,3.6Z",
    transform: "translate(-1.248 -8.003)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2073.9,1978.362l5.786,3.342v-.221l-5.787-3.343,0,.223Zm6.012,3.95a.226.226,0,0,1-.111-.03l-6.231-3.6a.218.218,0,0,1-.112-.192l-.006-.736a.223.223,0,0,1,.335-.195l6.23,3.6a.219.219,0,0,1,.111.191l.008.736a.223.223,0,0,1-.112.193A.213.213,0,0,1,2079.912,1982.313Z",
    transform: "translate(-1.161 -7.917)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2082.412,1982.226l6.017-3.476,0-.737-6.012,3.476Z",
    transform: "translate(-3.661 -8.051)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2082.556,1981.531l0,.221,5.567-3.218,0-.221-5.567,3.217Zm-.229.83a.229.229,0,0,1-.113-.03.223.223,0,0,1-.108-.193l.006-.736a.223.223,0,0,1,.111-.191l6.013-3.476a.224.224,0,0,1,.334.195l-.006.737a.218.218,0,0,1-.109.19l-6.017,3.474A.219.219,0,0,1,2082.327,1982.361Z",
    transform: "translate(-3.576 -7.965)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M2080,1984.993l-6.233-3.6,0-.739,6.23,3.6Z",
    transform: "translate(-1.248 -8.788)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2073.9,1981.178l5.786,3.342v-.221l-5.787-3.344,0,.223Zm6.012,3.95a.221.221,0,0,1-.111-.031l-6.231-3.6a.219.219,0,0,1-.112-.19l-.006-.739a.223.223,0,0,1,.335-.193l6.23,3.6a.218.218,0,0,1,.111.188l.008.739a.219.219,0,0,1-.112.192A.208.208,0,0,1,2079.912,1985.129Z",
    transform: "translate(-1.161 -8.703)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M2080,1987.81l-6.233-3.6,0-.738,6.23,3.6Z",
    transform: "translate(-1.248 -9.574)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2073.9,1983.995l5.786,3.341v-.223l-5.787-3.342,0,.224Zm6.012,3.95a.226.226,0,0,1-.111-.03l-6.231-3.6a.22.22,0,0,1-.112-.192l-.006-.737a.228.228,0,0,1,.111-.195.224.224,0,0,1,.224,0l6.23,3.6a.223.223,0,0,1,.111.191l.008.736a.223.223,0,0,1-.112.2A.214.214,0,0,1,2079.912,1987.944Z",
    transform: "translate(-1.161 -9.488)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2082.412,1987.858l6.017-3.476,0-.737-6.012,3.474Z",
    transform: "translate(-3.661 -9.623)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2082.556,1987.162l0,.221,5.567-3.215,0-.223-5.567,3.216Zm-.229.831a.229.229,0,0,1-.113-.03.223.223,0,0,1-.108-.2l.006-.736a.227.227,0,0,1,.111-.191l6.013-3.474a.227.227,0,0,1,.223,0,.221.221,0,0,1,.112.195l-.006.737a.219.219,0,0,1-.109.19l-6.017,3.474A.219.219,0,0,1,2082.327,1987.994Z",
    transform: "translate(-3.576 -9.537)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2082.412,1985.042l6.017-3.476,0-.737-6.012,3.474Z",
    transform: "translate(-3.661 -8.837)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2082.556,1984.348l0,.221,5.567-3.216,0-.222-5.567,3.218Zm-.229.829a.223.223,0,0,1-.113-.031.219.219,0,0,1-.108-.192l.006-.739a.221.221,0,0,1,.111-.188l6.013-3.476a.22.22,0,0,1,.223,0,.222.222,0,0,1,.112.195l-.006.735a.221.221,0,0,1-.109.192l-6.017,3.473A.214.214,0,0,1,2082.327,1985.177Z",
    transform: "translate(-3.576 -8.751)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2085.463,1986.859l5.876-3.359-2.852-1.649-5.865,3.374Z",
    transform: "translate(-3.72 -9.122)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2082.982,1985.139l2.4,1.378,5.433-3.1-2.409-1.392-5.42,3.116Zm2.4,1.855a.229.229,0,0,1-.111-.028l-2.84-1.634a.223.223,0,0,1,0-.386l5.864-3.371a.218.218,0,0,1,.223,0l2.853,1.649a.218.218,0,0,1,.11.193.221.221,0,0,1-.11.19l-5.88,3.359A.225.225,0,0,1,2085.378,1986.994Z",
    transform: "translate(-3.635 -9.037)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M2080,1992.341l-6.233-3.6,0-.738,6.23,3.6Z",
    transform: "translate(-1.248 -10.839)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2073.9,1988.526l5.786,3.343v-.223l-5.787-3.344,0,.224Zm6.012,3.952a.226.226,0,0,1-.111-.03l-6.231-3.6a.214.214,0,0,1-.112-.189l-.006-.738a.224.224,0,0,1,.335-.195l6.23,3.6a.22.22,0,0,1,.111.19l.008.736a.226.226,0,0,1-.112.2A.214.214,0,0,1,2079.912,1992.477Z",
    transform: "translate(-1.161 -10.753)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2082.412,1992.389l6.017-3.475,0-.737-6.012,3.474Z",
    transform: "translate(-3.661 -10.887)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2082.556,1991.695l0,.223,5.567-3.217,0-.223-5.567,3.217Zm-.229.831a.229.229,0,0,1-.113-.03.226.226,0,0,1-.108-.2l.006-.736a.224.224,0,0,1,.111-.19l6.013-3.474a.223.223,0,0,1,.334.192l-.006.739a.221.221,0,0,1-.109.19l-6.017,3.475A.219.219,0,0,1,2082.327,1992.526Z",
    transform: "translate(-3.576 -10.802)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M2085.4,1993.619l-.624-.358v-4.683l-2.375-1.413,0-.766c1,.6,1.992,1.208,2.994,1.787Z",
    transform: "translate(-3.659 -10.391)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2084.916,1993.046l.177.1v-4.921c-.635-.366-1.264-.746-1.893-1.127l-.657-.4,0,.247,2.267,1.349a.223.223,0,0,1,.11.191l0,4.554Zm.4.71a.217.217,0,0,1-.111-.03l-.622-.358a.221.221,0,0,1-.112-.192v-4.557l-2.266-1.349a.225.225,0,0,1-.11-.193l.005-.763a.225.225,0,0,1,.114-.193.219.219,0,0,1,.223,0l.991.595c.665.4,1.328.8,2,1.187a.223.223,0,0,1,.113.193v5.433a.225.225,0,0,1-.221.223Z",
    transform: "translate(-3.573 -10.306)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M2093.64,1990l-.622-.359V1984.2l.622.359Z",
    transform: "translate(-6.62 -9.778)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2093.154,1989.422l.178.1V1984.6l-.178-.1v4.921Zm.4.709a.207.207,0,0,1-.11-.03l-.621-.359a.219.219,0,0,1-.113-.191v-5.434a.223.223,0,0,1,.113-.193.227.227,0,0,1,.222,0l.621.359a.221.221,0,0,1,.111.192v5.435a.219.219,0,0,1-.111.191A.21.21,0,0,1,2093.553,1990.13Z",
    transform: "translate(-6.534 -9.692)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2087.161,1987.922l4.675-2.667v4.2l.6-.347c0-2.032,0-4.818,0-6.85l-5.878,3.358.006,2.1v4.751l.6-.345Z",
    transform: "translate(-4.817 -9.235)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2086.69,1985.656l.006,6.338.156-.09v-4.067a.223.223,0,0,1,.114-.193l4.675-2.667a.222.222,0,0,1,.333.193v3.812l.157-.092c0-1.893,0-4.4-.006-6.337l-5.434,3.1Zm.385,6.376h0Zm-.6.568a.236.236,0,0,1-.114-.03.224.224,0,0,1-.11-.193l-.006-6.849a.223.223,0,0,1,.114-.193l5.878-3.358a.221.221,0,0,1,.331.193c0,2.031.005,4.817.005,6.849a.22.22,0,0,1-.11.193l-.6.346a.221.221,0,0,1-.333-.191v-3.816l-4.234,2.416v4.066a.22.22,0,0,1-.111.192l-.6.345A.219.219,0,0,1,2086.474,1992.6Z",
    transform: "translate(-4.731 -9.149)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2092.781,1985.594a.182.182,0,0,1-.089-.025.179.179,0,0,1-.089-.154v-.937a.179.179,0,0,1,.089-.154l.4-.234a.177.177,0,1,1,.176.308l-.313.18v.529l.141-.083a.178.178,0,1,1,.18.308l-.411.236A.181.181,0,0,1,2092.781,1985.594Z",
    transform: "translate(-6.505 -9.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2091.8,1986.186a.33.33,0,0,1-.308-.236.967.967,0,0,1,.253-1.052.324.324,0,0,1,.415.021.178.178,0,0,1-.215.279.4.4,0,0,0-.147.3.687.687,0,0,0,.021.315.344.344,0,0,0,.066-.147.177.177,0,1,1,.34.1.509.509,0,0,1-.35.408A.317.317,0,0,1,2091.8,1986.186Z",
    transform: "translate(-6.178 -9.955)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2091.008,1986.708a.179.179,0,0,1-.177-.18v-.937a.176.176,0,1,1,.353,0v.937A.178.178,0,0,1,2091.008,1986.708Z",
    transform: "translate(-6.01 -10.117)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2088.825,1987.881a.177.177,0,0,1-.177-.178v-.939a.179.179,0,0,1,.089-.154l.38-.22a.179.179,0,0,1,.177.311l-.291.166v.836A.177.177,0,0,1,2088.825,1987.881Z",
    transform: "translate(-5.401 -10.383)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2088.825,1987.6a.177.177,0,0,1-.089-.331l.281-.162a.177.177,0,1,1,.177.308l-.28.161A.171.171,0,0,1,2088.825,1987.6Z",
    transform: "translate(-5.401 -10.583)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2087.833,1987.363h0Zm.061.173a.513.513,0,0,0-.13.293.642.642,0,0,0,.013.292.56.56,0,0,0,.117-.275.727.727,0,0,0,0-.31Zm-.1.63h0Zm-.041.339a.279.279,0,0,1-.144-.04c-.19-.11-.211-.394-.211-.513a.858.858,0,0,1,.345-.745h0a.308.308,0,0,1,.444.114,1.008,1.008,0,0,1-.267,1.137A.335.335,0,0,1,2087.754,1988.505Z",
    transform: "translate(-5.053 -10.603)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2092.781,1985.334a.178.178,0,0,1-.089-.332l.282-.163a.178.178,0,0,1,.177.309l-.282.162A.187.187,0,0,1,2092.781,1985.334Z",
    transform: "translate(-6.504 -9.949)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2089.931,1987.244a.177.177,0,0,1-.177-.177v-.94a.178.178,0,0,1,.089-.154l.38-.219a.178.178,0,0,1,.177.308l-.291.168v.837A.177.177,0,0,1,2089.931,1987.244Z",
    transform: "translate(-5.71 -10.205)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2089.931,1986.966a.178.178,0,0,1-.089-.332l.281-.164a.178.178,0,0,1,.177.309l-.281.162A.19.19,0,0,1,2089.931,1986.966Z",
    transform: "translate(-5.709 -10.405)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceTag);
export default __webpack_public_path__ + "static/media/place-tag.d3bd72decc3a6ff6093ffea87930bfc2.svg";
export { ForwardRef as ReactComponent };